var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "h-100 px-0 mx-0 position-relative"
  }, [_c('b-row', {
    staticClass: "h-100 px-0 mx-0"
  }, [_c('b-col', {
    staticClass: "d-none d-md-block px-0 bg-light border rounded-left overflow-hidden",
    attrs: {
      "cols": "2"
    }
  }, [_c('Messages')], 1), _vm._v(" "), _c('b-col', {
    staticClass: "px-0 bg-light border rounded-right overflow-hidden",
    attrs: {
      "cols": "12",
      "md": "10",
      "xl": "7"
    }
  }, [_c('MessageThread')], 1), _vm._v(" "), _c('b-col', {
    staticClass: "d-none d-xl-block overflow-hidden",
    attrs: {
      "cols": "3"
    }
  }, [(!_vm.isMobile) ? _c('MessageDetails') : _vm._e()], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "enter-left"
    }
  }, [(_vm.isMobile && _vm.showMessages) ? _c('Messages', {
    attrs: {
      "id": "messages-popout"
    }
  }) : _vm._e()], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22decce1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/Pages/Messaging/Messaging.vue
// module id = 0f7D
// module chunks = 2